import LeftArrow from "./LeftArrow";
import NextArrowIcon from "./NextArrow";

export { LeftArrow, NextArrowIcon };
